import * as Mui from "@mui/material";
import { CheckBoxProps } from "./Types";
import { destructProps, useFormInputs } from "./Utils";

const FormCheckbox = (props: CheckBoxProps) => {
  const { formProps, baseProps } = destructProps(props);

  const form = useFormInputs(formProps);

  const error = baseProps.error || !!form?.error;
  const helperText = baseProps.helperText || form?.error?.message?.toString() || "";
  
  return (
    <Mui.FormControl
      error={error}
    >
      <Mui.FormControlLabel
        control={(
          <Mui.Checkbox
            {...baseProps}
            checked={Boolean(form?.value)}
            onChange={(event) => form?.onChange && form.onChange(event.currentTarget.checked)}
          />
        )}
        label={baseProps.label}
      />
      <Mui.FormHelperText>{helperText}</Mui.FormHelperText>
    </Mui.FormControl>
  );
}

export default FormCheckbox;